
jQuery(function () {
    updateCategoryCountOnTargetFilter();
    setTimeout(function () {
        $('.ProductFamily--Row ').removeClass('opacityClass');
    }, 500);
    setTimeout(function () {
        hideZeroCard();
    }, 800);
    var slideTogleSpeed = 200;
    $(".ab_accordion_header").on("click keypress", function (event) {
        if (
            event.type === "click" ||
            (event.type === "keypress" && event.key === "Enter")
        ) {
            let $this = $(this);
            let $content = $this.siblings(".ab_accordion_content");
            let isExpanded = $this.attr("aria-expanded") === "true";

            // Set this header and content
            $this.attr("aria-expanded", !isExpanded);
            $content.attr("aria-hidden", isExpanded);
            $content.slideToggle(slideTogleSpeed);

            // Set all other headers and contents to collapsed/hidden
            $(".ab_accordion_header").not($this).attr("aria-expanded", "false");
            $(".ab_accordion_content")
                .not($content)
                .attr("aria-hidden", "true")
                .slideUp(slideTogleSpeed);

            // Toggle active class
            $this.toggleClass("activeFilter");
            $(".ab_accordion_header").not($this).removeClass("activeFilter");
        }
    });
});

$(document).on('mouseup', function (e) {
    var slideTogleSpeed = 200;
    if (!$(".ab_accordion_header").is(e.target) && $(".ab_accordion_content").has(e.target).length === 0) {
        //    $('.ab_accordion_content').slideUp(slideTogleSpeed);
        //    $('.ab_accordion_header').removeClass('activeFilter');
        //}
        //if ($(window).width() > 991 && $(".ab_accordion_content.product-filter-btn--is-active").has(e.target).length === 0) {

        $('.ab_accordion_content').slideUp(slideTogleSpeed);
        $('.ab_accordion_header').removeClass('activeFilter');
    }
});
let $filterCheckboxes = $('.product-filter-btn');


//mobile, Ipad filter functionlity
$('.close-icon, .product-filter-apply').on('click', function () {
    setTimeout(function () {
        hideZeroCard();
    }, 800);
    $(this).parents('.js-product-filter').removeClass('product-filter--is-active');
    $('body').removeClass('overflow-hidden');
});
$('.product-filter-toggle-mobile, .product-filter-toggle-label').on('click', function () {
    $(this).parents('.js-product-filter').addClass('product-filter--is-active');
    $('body').addClass('overflow-hidden');
    $('.product-filter-item').removeClass('accordion-expanded');
    $('.accordion-title i').removeClass('icon-arrow-up');
    $('.accordion-title i').addClass('icon-arrow-down');
});

//desk filter functionlity 
var appliedFilterObject = {};
//var selectedFilters = {};
$filterCheckboxes.on('click', function () {
    var selectedFilters = {};
    $(this).toggleClass('product-filter-btn--is-active');
    $('.ProductFamily--Row ').addClass('opacityClass')
    setTimeout(function () {
        $('.ProductFamily--Row ').removeClass('opacityClass');
    }, 900);
    $filterCheckboxes.filter('.product-filter-btn--is-active').each(function () {

        let parentAttrKey = $(this).parents('.js-product-filter-item').attr('data-filter-group');
        if (!selectedFilters.hasOwnProperty($(this).parents('.js-product-filter-item').attr('data-filter-group'))) {
            selectedFilters[$(this).parents('.js-product-filter-item').attr('data-filter-group')] = [];
        }
        selectedFilters[parentAttrKey].push($(this).attr('data-filter-name').toLowerCase());
    });
    if (window.matchMedia('(min-width:991px)').matches) {
        applyFilter(selectedFilters);

        $('.js-product-filter-reset-all, .clear-tags, .activeFilterLable').on("click", function () {
            selectedFilters = {};
            updateCategoryCount();
            $('.clear-tags').css('display', 'none');

        });
        appliedFilterObject = {};
        $('.product-filter-applied-list').empty();
        for (var k in selectedFilters)
            appliedFilterObject[k] = selectedFilters[k];
        if ($('.product-filter-btn--is-active').length) {

            $('.product-filter-btn--is-active').each(function () {
                let activeLable = $(this).text();
                $('.product-filter-applied-list').append('<button aria-label="selected filter label: ' +
                    activeLable +
                    '" class="activeFilterLable">' +
                    activeLable +
                    '<i class="icon icon-validation-cross"></i>' +
                    "</button>");
                $('.clear-tags').css('display', 'inline-block');
            })
            let $activeFilterLable = $('.activeFilterLable');

            $activeFilterLable.on('click', function () {
                var removedLabel = $(this).text();
                // Update all filter buttons with the same label
                $(".product-filter-btn").each(function () {
                    if ($(this).text() === removedLabel) {
                        $(this).attr("aria-pressed", "false");
                    }
                });
                setTimeout(() => {
                    var $container = $(
                        ".product-filter-applied-list.js-product-filter-applied-list"
                    );
                    $container.focus();
                    $("#filterStatus").text(removedLabel + " Filter deselected");
                }, 100);

                //for scrolling to filterbtn
                //var $anchorC = $('.product-filter-toggle').offset();
                //var topSpace = 100;
                //var setTime = 500;
                //$('body, html').animate({
                //    scrollTop: $anchorC.top - topSpace
                //}, setTime);
                if ($('.activeFilterLable').length === 1) {
                    $('.activeFilterLable').css('display', 'none');
                    selectedFilters = {};
                    appliedFilterObject = {};
                    applyFilter(selectedFilters);
                    applyFilterMobCta(selectedFilters);
                    updateFilterText4MobBtn();
                    updateCategoryCount();
                    $('.clear-tags').css('display', 'none');
                    $('.product-filter-applied-list').empty();
                    $(".product-filter-btn--is-active").attr("aria-pressed", "false");
                    $('.product-filter-btn--is-active').removeClass('product-filter-btn--is-active')
                } else {
                    var removedLabel = $(this).text();
                    $(this).remove();
                    $filterCheckboxes.each(function () {
                        let allInnerLabel = $(this).text();
                        if (allInnerLabel === removedLabel) {
                            //$(this).click();
                            selectedFilters = {};
                            appliedFilterObject = {};
                            $(this).removeClass('product-filter-btn--is-active');
                            $(this).attr("aria-pressed", "false");
                            $filterCheckboxes.filter('.product-filter-btn--is-active').each(function () {
                                let parentAttrKey = $(this).parents('.js-product-filter-item').attr('data-filter-group');
                                if (!selectedFilters.hasOwnProperty($(this).parents('.js-product-filter-item').attr('data-filter-group'))) {
                                    selectedFilters[$(this).parents('.js-product-filter-item').attr('data-filter-group')] = [];
                                }
                                selectedFilters[parentAttrKey].push($(this).attr('data-filter-name').toLowerCase());
                                for (var s in selectedFilters)
                                    appliedFilterObject[s] = selectedFilters[s];
                                $('.product-filter-item').removeClass('accordion-expanded');
                                $('.accordion-title i').removeClass('icon-arrow-up');
                                $('.accordion-title i').addClass('icon-arrow-down');
                                applyFilter(selectedFilters);
                                applyFilterMobCta(selectedFilters);
                                updateFilterText4MobBtn();
                                updateCategoryCount();
                                activeLabelAppend(selectedFilters);
                                disableparent();
                                $('.clear-tags').css('display', 'inline-block');
                                if ($('.product-filter-applied-list').children().length === 0) {

                                    $('.clear-tags').css('display', 'none');
                                } else {
                                    $('.clear-tags').css('display', 'inline-block');
                                }
                            });
                        }
                    });
                }
            });
            applyFilter(selectedFilters);
            updateCategoryCount();

        } else if ($('.product-filter-btn--is-active').length === 0) {
            $('.clear-tags').css('display', 'none');
            let selectedFilters = {};
            let appliedFilterObject = {};
            applyFilter(selectedFilters);
            updateCategoryCount();

        } else {
            updateCategoryCount();
            $('.product-filter-btn').removeClass('disabled').prop('disabled', false);
            $('.productBoxWrapper').removeClass('hidden');
        }

    } else {
        applyFilterMobCta(selectedFilters);
        updateFilterText4MobBtn()
        disableEmptyCategories(selectedFilters);
        activeLabelAppend(selectedFilters);
        disableparent();
        $('.js-product-filter-apply').on('click', function () {

            $('.js-product-filter-reset-all, .clear-tags').on('click', function () {
                selectedFilters = {};
                updateCategoryCount();
                $('.clear-tags').css('display', 'none');

            });
            appliedFilterObject = {};
            $('.product-filter-applied-list').empty();
            for (var m in selectedFilters)
                appliedFilterObject[m] = selectedFilters[m];
            if ($('.product-filter-btn--is-active').length) {

                $('.product-filter-btn--is-active').each(function () {
                    let activeLable = $(this).text();
                    $('.product-filter-applied-list').append('<button aria-label="selected filter label" class="activeFilterLable">' + activeLable + '<i class="icon icon-validation-cross"></i>' + '</button>');
                    $('.clear-tags').css('display', 'inline-block');
                })
                let $activeFilterLable = $('.activeFilterLable');

                $activeFilterLable.on('click', function () {


                    if ($('.activeFilterLable').length === 1) {
                        $('.activeFilterLable').css('display', 'none');
                        selectedFilters = {};
                        appliedFilterObject = {};
                        applyFilter(selectedFilters);
                        applyFilterMobCta(selectedFilters);
                        updateFilterText4MobBtn();
                        updateCategoryCount();
                        $('.clear-tags').css('display', 'none');
                        $('.product-filter-applied-list').empty();

                        $('.product-filter-btn--is-active').removeClass('product-filter-btn--is-active')
                    } else {
                        var removedLabel = $(this).text();
                        $(this).remove();
                        $filterCheckboxes.each(function () {
                            let allInnerLabel = $(this).text();
                            if (allInnerLabel === removedLabel) {
                                //$(this).click();
                                selectedFilters = {};
                                appliedFilterObject = {};
                                $(this).removeClass('product-filter-btn--is-active');
                                $filterCheckboxes.filter('.product-filter-btn--is-active').each(function () {
                                    let parentAttrKey = $(this).parents('.js-product-filter-item').attr('data-filter-group');
                                    if (!selectedFilters.hasOwnProperty($(this).parents('.js-product-filter-item').attr('data-filter-group'))) {
                                        selectedFilters[$(this).parents('.js-product-filter-item').attr('data-filter-group')] = [];
                                    }
                                    selectedFilters[parentAttrKey].push($(this).attr('data-filter-name').toLowerCase());

                                    for (var s in selectedFilters)
                                        appliedFilterObject[s] = selectedFilters[s];
                                    $('.product-filter-item').removeClass('accordion-expanded');
                                    $('.accordion-title i').removeClass('icon-arrow-up');
                                    $('.accordion-title i').addClass('icon-arrow-down');
                                    applyFilter(selectedFilters);
                                    applyFilterMobCta(selectedFilters);
                                    updateFilterText4MobBtn();
                                    updateCategoryCount();
                                    activeLabelAppend(selectedFilters);
                                    disableparent();
                                    $('.clear-tags').css('display', 'inline-block');
                                    if ($('.product-filter-applied-list').children().length === 0) {

                                        $('.clear-tags').css('display', 'none');
                                    } else {
                                        $('.clear-tags').css('display', 'inline-block');
                                    }
                                });
                            }
                        });
                    }
                });
                applyFilter(selectedFilters);
                updateCategoryCount();

            } else if ($('.product-filter-btn--is-active').length === 0) {

                $('.clear-tags').css('display', 'none');
                let selectedFilters = {};
                applyFilter(selectedFilters);
                updateCategoryCount();

            } else {
                updateCategoryCount();
                $('.product-filter-btn').removeClass('disabled').prop('disabled', false);
                $('.productBoxWrapper').removeClass('hidden');
            }
        });
    }

    let filterName = $(this).data("filter-name");
    let isPressed = $(this).attr("aria-pressed") === "true";
    //toggle
    $(this).attr("aria-pressed", !isPressed);
    // Add live region div if not already in DOM
    if ($("#filterStatus").length === 0) {
        $("body").append(
            '<div id="filterStatus" aria-live="assertive" aria-atomic="true" class="sr-only"></div>'
        );
    }
    $("#filterStatus").text(
        `${filterName} filter ${!isPressed ? "selected" : "deselected"}`
    );
});
//close btn last applied filter restore functionality
$('.close-icon').on('click', function () {

    if (Object.keys(appliedFilterObject).length === 0 && !$('.product-filter-btn--is-active').hasClass('product-filter-btn--is-active')) {
        selectedFilters = {};
        applyFilter(selectedFilters);
        updateCategoryCount();

    } else {
        var selectedFilters = {};
        $('.productBoxWrapper').removeClass('.mobActive');
        $('.filter-tags').empty();
        $('.disabled').removeClass('disabled').prop('disabled', false);
        $('.product-filter-btn').removeClass('disabled').prop('disabled', false);
        $('.product-filter-item').removeClass('accordion-expanded');
        $('.accordion-title i').removeClass('icon-arrow-up');
        $('.accordion-title i').addClass('icon-arrow-down');
        let totalVisibleProducts = 0;
        $('.js-product-filter-family').each(function () {
            var $this = $(this);
            let categoryCount = $this.find('.productBoxWrapper').length;
            let categoryNoneCount = $this.find('.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="hidden"]').length;
            let visibleCategoryProductsT = categoryCount - categoryNoneCount;
            totalVisibleProducts += visibleCategoryProductsT;
            $('.mobActiveProductsCount').text(totalVisibleProducts);
        })
        $('.product-filter-btn--is-active').removeClass('product-filter-btn--is-active');

        for (var l in appliedFilterObject) selectedFilters[l] = appliedFilterObject[l];

        $.each(selectedFilters, function (_newMobileName, mobileSelectedV) {
            $.each(mobileSelectedV, function (_, mobileSelectedSingleV) {
                $filterCheckboxes.each(function () {
                    let mobileDataFilterValue = $(this).attr('data-filter-name').toLowerCase();
                    mobileSelectedSingleV = mobileSelectedSingleV.toString();
                    if (mobileDataFilterValue === mobileSelectedSingleV) {
                        $(this).addClass('product-filter-btn--is-active');
                        $('.product-filter-item').removeClass('accordion-expanded');
                        $('.accordion-title i').removeClass('icon-arrow-up');
                        $('.accordion-title i').addClass('icon-arrow-down');
                    } else {

                    }
                });
            });
        });
        updateCategoryCount();
        applyFilter(selectedFilters);
        activeLabelAppend(selectedFilters);
        disableparent();
    }
});
//$('.Tags__Button, .tag_Menu_Button').on('click', function () {
//    applyFilter(selectedFilters);
//})
let applyFilter = function (selectedFilters) {

    var $filteredResults = $('.productBoxWrapper');
    $.each(selectedFilters, function (name, filterValues) {
        $filteredResults = $filteredResults.filter(function (_index, product) {
            var currentKeyValues = [];
            var matched = false,
                totalValues = $(product).data('filter-group-' + name + '');
            currentKeyValues.push(totalValues);
            $.each(currentKeyValues, function (_, currentFilterValue) {
                currentFilterValue = currentFilterValue.toString();
                if ($.inArray(currentFilterValue, filterValues) !== -1) {
                    matched = true;
                    return false;
                } else {
                    var resultNew = typeof currentFilterValue === 'string' ? currentFilterValue.split('|') : '';
                    $.each(resultNew, function (_newIndex, splittedValue) {
                        if ($.inArray(splittedValue, filterValues) !== -1) {
                            matched = true;
                            return false;
                        }
                    });
                }
            });
            return matched;
        });
    });
    if (window.matchMedia('(max-width:991px)').matches) {
        $('.productBoxWrapper').addClass('mobActive').filter($filteredResults).removeClass('mobActive');
    }
    $('.productBoxWrapper').addClass('hidden').filter($filteredResults).removeClass('hidden');
    //total required functions
    hideEmptyHeading();
    updateFilterText();
    disableEmptyCategories(selectedFilters);
    activeLabelAppend(selectedFilters);
    disableparent();

}
//for mobile apply filter CTA count
let applyFilterMobCta = function (selectedFilters) {
    var $filteredResults = $('.productBoxWrapper');
    $.each(selectedFilters, function (name, filterValues) {
        $filteredResults = $filteredResults.filter(function (_index, product) {
            var currentKeyValues = [];
            var matched = false,
                totalValues = $(product).data('filter-group-' + name + '');
            currentKeyValues.push(totalValues);
            $.each(currentKeyValues, function (_, currentFilterValue) {
                currentFilterValue = currentFilterValue.toString();
                if ($.inArray(currentFilterValue, filterValues) !== -1) {
                    matched = true;
                    return false;
                } else {
                    var resultNew = typeof currentFilterValue === 'string' ? currentFilterValue.split('|') : '';
                    $.each(resultNew, function (_newIndex, splittedValue) {
                        if ($.inArray(splittedValue, filterValues) !== -1) {
                            matched = true;
                            return false;
                        }
                    });
                }
            });
            return matched;
        });
    });
    $('.productBoxWrapper').addClass('mobActive').filter($filteredResults).removeClass('mobActive');
}
//hide heading if all product cards are hidden
let hideEmptyHeading = function () {
    $('.js-product-filter-family').each(function () {
        var $this = $(this);
        var $lis = $this.find('.productBoxWrapper');
        if ($lis.length === 0) {
            return;
        }
        if ($lis.filter('.hidden').length === $lis.length) {
            $this.addClass('hidden');
        } else {
            $this.removeClass('hidden');
        }
    });
}
// total product count and current filter count
let updateFilterText = function () {
    let totalProducts = $('.productBoxWrapper').length;
    let hiddenProducts = $('.productBoxWrapper[class*="hidden"]').length;
    let visibleProducts = totalProducts - hiddenProducts;
    $('.productCount').text(visibleProducts);

}
//filter count for mobile apply filter btn
let updateFilterText4MobBtn = function () {
    //let totalProductsMob = $('.productBoxWrapper').length;
    //let mobActiveProducts = $('.productBoxWrapper[class*="mobActive"]').length;
    //let visibleProductsMob = totalProductsMob - mobActiveProducts;
    //$('.mobActiveProductsCount').text(visibleProductsMob);

    let totalVisibleProducts = 0;
    $('.js-product-filter-family').each(function () {
        var $this = $(this);
        let categoryCount = $this.find('.productBoxWrapper').length;
        let categoryNoneCount = $this.find('.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="mobActive"], .productBoxWrapper[class*="hidden"]').length;
        let visibleCategoryProductsT = categoryCount - categoryNoneCount;
        totalVisibleProducts += visibleCategoryProductsT;
        $('.mobActiveProductsCount').text(totalVisibleProducts);
    })
}

//function updateCategoryCount() {
let updateCategoryCount = function () {
    $('.js-product-filter-family').each(function () {
        var $this = $(this);
        let categoryCount = $this.find('.productBoxWrapper').length;
        let categoryHiddenCount = $this.find('.productBoxWrapper[class*="hidden"], .productBoxWrapper[style*="display: none"]').length;
        let visibleCategoryProductsT = categoryCount - categoryHiddenCount;
        let visibleCategoryProducts = '(' + visibleCategoryProductsT + ')'
        $this.find('.categoryProductsCount').text(visibleCategoryProducts);
    })
}
//function zerCategoryCount() {
let hideZeroCard = function () {
    $('.ProductDetailCard').each(function () {
        // Find the categoryProductsCount element inside the current .ProductDetailCard
        var countText = $(this).find('.categoryProductsCount').text().trim();

        // Check if the count is '(0)' and hide the corresponding .row
        if (countText === "(0)") {

            $(this).find('.row').addClass('d-none');
        }
        else {
            $(this).find('.row').removeClass('d-none');
            let allCardsHidden = $('.ProductDetailCard.js-product-filter-family').filter(function () {
                let isCardHidden = $(this).hasClass('hidden') || $(this).is(':hidden');
                let hasHiddenChildren = $(this).find('.d-none').length > 0;

                return isCardHidden || hasHiddenChildren;
            }).length === $('.ProductDetailCard.js-product-filter-family').length;

            if (allCardsHidden) {
                $('.noProductmsg').removeClass('noProductmsg');
                $('.no_products_match').addClass('noProductmsg');
            }
            else {
                $('.noProductmsg').removeClass('noProductmsg');
            }
        }

    });
}

//function updateCategoryCount() {
let updateCategoryCountOnTargetFilter = function () {
    setTimeout(function () {
        $('.js-product-filter-family').each(function () {
            var $this = $(this);
            let categoryCount = $this.find('.productBoxWrapper').length;
            let categoryNoneCount = $this.find('.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="hidden"]').length;
            let visibleCategoryProductsT = categoryCount - categoryNoneCount;
            let visibleCategoryProducts = '(' + visibleCategoryProductsT + ')'
            $this.find('.categoryProductsCount').text(visibleCategoryProducts);
        })
    }, 500);
}


// append active label
let activeLabelAppend = function (selectedFilters) {
    $('.filter-tags').empty();
    for (var key in selectedFilters) {
        $('.product-filter-item[data-filter-group ="' + key + '"]').find('.product-filter-btn.product-filter-btn--is-active').each(function () {
            let innertext = $(this).text();
            // innertext = $(this).html();
            var datTotalValue = [];
            let datValue = $(this).data('filter-name');
            datTotalValue.push(datValue);
            var matched = false;
            $.each(datTotalValue, function (_, datCurentValue) {
                if (datCurentValue === 'number') {
                    datCurentValue = datCurentValue.toString();
                }
                datCurentValue = datCurentValue.toString();
                var datCurentValueNew = typeof datCurentValue === 'string' ? datCurentValue.split('|') : '';
                if (datCurentValueNew.length === 1) {
                    if (datCurentValue === selectedFilters[key]) {
                        matched = true;
                        return false;
                    }
                } else {
                    $.each(datCurentValueNew, function (_splittedIndex, splitteddatCurentValue) {
                        if (splitteddatCurentValue === selectedFilters[key]) {
                            matched = true;
                            return false;
                        }
                    });
                }
                return matched;
            });
            $('.product-filter-item[data-filter-group ="' + key + '"]').find('.filter-tags').append('<li>' + innertext.split('-').join(' ') + '</li>')
            if ($('.filter-tags').children().length > 1) {
                $('.filter-tags li:not(:last-child)').addClass("comma");
            }
        });
    }
}
//disable empty categories related checkbox
let disableEmptyCategories = function (selectedFilters) {
    var $filteredResultsForFirstSelection = [];
    var $filteredResultsForEach = [];
    var filteredResultTotalValues = [];
    $(".product-filter-btn").removeClass('disabled').prop('disabled', false);
    for (var key in selectedFilters) {
        var $filteredResultsForFirstSelection = [];
        var $filteredResultsForEach = [];
        var firstSelectionValueNew = typeof selectedFilters[key] === 'string' ? selectedFilters[key].split('|') : selectedFilters[key];
        if (firstSelectionValueNew.length == 1) {
            var $filteredResultsForEach = [];
            var $filteredResultSingleV = $(".productBoxWrapper").filter(function (filterIndex, filteredResultProduct) {
                var currentKeyValues = [];
                var matched = false,
                    totalValues = $(filteredResultProduct).data('filter-group-' + key + '');
                if (totalValues != "") {
                    currentKeyValues.push(totalValues);
                }
                $.each(currentKeyValues, function (_, currentFilterValue) {
                    currentFilterValue = currentFilterValue.toString();
                    if (typeof currentFilterValue == 'number') {
                        var currentFilterValue = currentFilterValue.toString();
                    }
                    var resultNew = typeof currentFilterValue === 'string' ? currentFilterValue.split('|') : currentFilterValue
                    if (typeof currentFilterValue !== 'undefined' || typeof resultNew !== 'undefined') {
                        if (selectedFilters[key] == currentFilterValue) {
                            matched = true;
                            return false;
                        } else {
                            $.each(resultNew, function (_, splittedValue) {
                                if (selectedFilters[key] == splittedValue) {
                                    matched = true;
                                    return false;
                                }
                            });
                        }
                    }
                });
                return matched;
            });
            $filteredResultsForFirstSelection.push($filteredResultSingleV);
        } else if (firstSelectionValueNew.length > 1) {
            $.each(firstSelectionValueNew, function (_, splittedfirstSelection) {
                var $filteredResultFirstS = $(".productBoxWrapper").filter(function (filterIndex, filteredResultProduct) {
                    var datasetTotalValues = [];
                    var matchValue = false,
                        datasetV = $(filteredResultProduct).data('filter-group-' + key + '');
                    if (datasetV != "") {
                        datasetTotalValues.push(datasetV);
                    }
                    $.each(datasetTotalValues, function (_, datasetTotalVal) {
                        if (typeof datasetTotalVal == 'number') {
                            var datasetTotalVal = datasetTotalVal.toString();
                        }
                        var ValueNew = typeof datasetTotalVal === 'string' ? datasetTotalVal.split('|') : datasetTotalVal
                        if (typeof datasetTotalVal !== 'undefined' || typeof ValueNew !== 'undefined') {
                            if (splittedfirstSelection == datasetTotalVal) {
                                matchValue = true;
                                return false;
                            } else if (ValueNew.length > 1) {
                                $.each(ValueNew, function (_, splittedValue) {
                                    if (splittedfirstSelection == splittedValue) {
                                        matchValue = true;
                                        return false;
                                    }
                                });
                            }
                        }
                    });
                    return matchValue;
                });
                $filteredResultsForFirstSelection.push($filteredResultFirstS);

            });
        }
        $.each($filteredResultsForFirstSelection, function (_, eachArray) {
            $.each(eachArray, function (_, eachElem) {
                $filteredResultsForEach.push(eachElem);
            })
        })
        $filteredResultsForFirstSelection = [];
        $filteredResultsForFirstSelection.push($filteredResultsForEach);
        $.each($filteredResultsForFirstSelection, function (_, firstSelectionProduct) {
            $(".product-filter-btn:not('.product-filter-btn--is-active')").each(function (_, nonActiveBtn) {
                var $currentCheckbox = $(nonActiveBtn);
                var currentValue = $(nonActiveBtn).attr('data-filter-name');
                const checkboxParentValueStr = $(this).parents('.js-product-filter-item').attr('data-filter-group');
                var match = true;
                if ($currentCheckbox.prop('disabled')) { } else {
                    $.each(firstSelectionProduct, function (_, currentSelectionProduct) {

                        var datasetTotalValues = [];
                        var datasetV = $(currentSelectionProduct).data('filter-group-' + checkboxParentValueStr + '');
                        if (datasetV != "") {
                            datasetTotalValues.push(datasetV);
                        }
                        $.each(datasetTotalValues, function (_, datasetTotalVal) {
                            if (typeof datasetTotalVal !== 'undefined' || typeof firstSelectionValueNew !== 'undefined') {
                                if (typeof datasetTotalVal == 'number') {
                                    var datasetTotalVal = datasetTotalVal.toString();
                                }
                                var firstSelectionValueNew = typeof datasetTotalVal === 'string' ? datasetTotalVal.split('|') : datasetTotalVal
                                if (currentValue == datasetTotalVal) {
                                    match = false;
                                } else if (firstSelectionValueNew.length > 1) {
                                    $.each(firstSelectionValueNew, function (_, splittedValue) {
                                        if (currentValue == splittedValue) {
                                            match = false;
                                        }
                                    });
                                }
                            }
                        });

                    });
                    if (checkboxParentValueStr == key) {
                        $currentCheckbox.removeClass('disabled').prop('disabled', false);
                    } else
                        if (match == false) {
                            $currentCheckbox.removeClass('disabled').prop('disabled', false);
                        } else {
                            $currentCheckbox.addClass('disabled').prop('disabled', true);
                        }
                }
            });
        });
    }
    if (Object.keys(selectedFilters).length === 0) {
        $('.product-filter-btn').removeClass('disabled').prop('disabled', false);
    }
}
// reset btn
$('.js-product-filter-reset-all, .clear-tags').on('click', function (e) {

    updateCategoryCount();
    e.preventDefault();
    selectedFilters = {};
    appliedFilterObject = {};
    $('.product-filter-applied-list').empty();

    $('.js-product-filter-btn').removeClass('product-filter-btn--is-active');
    $('.product-filter-item').removeClass('accordion-expanded');
    $('.accordion-title i').removeClass('icon-arrow-up');
    $('.accordion-title i').addClass('icon-arrow-down');
    $('.productBoxWrapper').removeClass('hidden');
    $(".product-filter-btn[aria-pressed='true']").attr("aria-pressed", "false");
    let totalVisibleProducts = 0;
    $('.js-product-filter-family').each(function () {
        var $this = $(this);
        let categoryCount = $this.find('.productBoxWrapper').length;
        let categoryNoneCount = $this.find('.productBoxWrapper[style*="display: none"], .productBoxWrapper[class*="hidden"]').length;
        let visibleCategoryProductsT = categoryCount - categoryNoneCount;
        totalVisibleProducts += visibleCategoryProductsT;
        $('.mobActiveProductsCount').text(totalVisibleProducts);
    })
    applyFilter(selectedFilters);
})

//disable parent category if all children are disabled
let disableparent = function () {
    $('.product-filter-item').each(function () {
        var $thisDis = $(this);
        var $lisDisable = $thisDis.find('.product-filter-btn');
        if ($lisDisable.length === 0) {
            return;
        }
        if ($lisDisable.filter('.disabled').length === $lisDisable.length) {
            $thisDis.addClass('disabled').prop('disabled', true);
        } else {
            $thisDis.removeClass('disabled').prop('disabled', false);
        }
    });
}

updateFilterText();
updateFilterText4MobBtn();
updateCategoryCount();
disableparent();

//ga4 for mobile
// Declare a flag to track whether the dataLayer has already been triggered
let isDataLayerTriggered = false;

function GA4FilterMobApplied(totalMobCount, activeFilterMobString) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ga4_product_filter",
        "ga4_data": {
            "action_type": "Filter applied",
            "active_filter_choice": activeFilterMobString,
            "filter_result_count": totalMobCount
        }
    });
}

// Handle the click event
$('.product-filter-apply').on('click', function () {
    setTimeout(function () {
        // Only trigger the dataLayer if it hasn't been triggered already
        if (!isDataLayerTriggered) {
            var totalMobCount = $('.mobActiveProductsCount').text();

            // Get active filters
            var activeFiltersmob = $('.product-filter-applied-list .activeFilterLable');
            var filterValuesMob = [];

            activeFiltersmob.each(function () {
                var filterValueMob = $(this).text().trim();
                filterValuesMob.push(filterValueMob);
            });

            var activeFilterMobString = filterValuesMob.join(', ');

            GA4FilterMobApplied(totalMobCount, activeFilterMobString);

            // Set the flag to true to prevent multiple triggers
            // isDataLayerTriggered = true;
        }
    }, 300);
});

// Handle window resize event
window.addEventListener('resize', function () {
    // Reset the flag when the window is resized, so we can track the resize event again
    if (window.matchMedia('(max-width:990px)').matches && isDataLayerTriggered === false) {
        isDataLayerTriggered = false; // Reset flag when resizing happens
    }
});


//for desk ga4 
$('.product-filter-btn ').on('click', function () {
    if ($(this).hasClass('product-filter-btn--is-active')) {
        var totalCount = $('.productCount').text();
        //active filter get 
        var activeFilters = $('.product-filter-applied-list .activeFilterLable');
        var filterValues = [];

        activeFilters.each(function () {
            var filterValue = $(this).text().trim(); // Get inner text and remove extra spaces
            filterValues.push(filterValue);
        });
        if (window.matchMedia('(min-width:991px)').matches) {
            var activeFilterValuesString = filterValues.join(', ');
            GA4FilterApplied(totalCount, activeFilterValuesString);
        }
    }
})
function GA4FilterApplied(totalCount, activeFilterValuesString) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        "event": "ga4_product_filter",
        "ga4_data": {
            "action_type": "Filter applied",
            "active_filter_choice": activeFilterValuesString,
            "filter_result_count": totalCount
        }
    })
};
$('.js-product-filter-apply, .close-icon').on('click', function (_event) {
    $('.productBoxMain .productBoxText .title, .productBoxMain .productBoxText .paraDiv, .productBoxMain .productBoxText .js-review').css('height', 'auto');
})
$('.product-filter-mobile-bar').on('click keypress', function () {
    let totalCategoryProductsCount = 0;
    $('.js-product-filter-family').each(function () {
        let categoryProductsText = $(this).find('.categoryProductsCount').text().trim();
        let categoryProductsCount = parseInt(categoryProductsText.replace(/[^\d]/g, ''), 10);

        if (isNaN(categoryProductsCount)) {
            console.log('Invalid count:', categoryProductsText);
            categoryProductsCount = 0;
        }
        totalCategoryProductsCount += categoryProductsCount;
    });
    $('.mobActiveProductsCount').text(totalCategoryProductsCount);
})
$('.Tags__Button, .tag_Menu_Button, .js-product-filter-btn, .clear-tags, .js-product-filter-applied-list, .js-product-filter-reset-all ').on('click keypress', function () {
    updateCategoryCountOnTargetFilter();
    $('.ProductFamily--Row ').addClass('opacityClass')
    setTimeout(function () {
        $('.ProductFamily--Row ').removeClass('opacityClass');
    }, 900);
    setTimeout(function () {
        hideZeroCard();
    }, 800);
    setTimeout(function () {
        $('.noProductmsg').removeClass('noProductmsg');
        let allCardsHidden = $('.ProductDetailCard.js-product-filter-family').filter(function () {
            let isCardHidden = $(this).hasClass('hidden') || $(this).is(':hidden');
            let hasHiddenChildren = $(this).find('.d-none').length > 0;

            return isCardHidden || hasHiddenChildren;
        }).length === $('.ProductDetailCard.js-product-filter-family').length;

        if (allCardsHidden) {
            $('.noProductmsg').removeClass('noProductmsg');
            $('.no_products_match').addClass('noProductmsg');
        }
        else {
            $('.noProductmsg').removeClass('noProductmsg');
        }
    }, 200);
})


//document.addEventListener('click', function (e) {
//    if (e.target.closest('.ab_accordion_header')) {
//        const header = e.target.closest('.ab_accordion_header');
//        const content = header.parentNode.querySelector('.ab_accordion_content');
//        const isExpanded = header.getAttribute('aria-expanded') === 'true';

//        header.setAttribute('aria-expanded', !isExpanded);
//        content.setAttribute('aria-hidden', isExpanded);

//        // Announce the change to screen readers
//        const announcement = !isExpanded ?
//            `${header.textContent.trim()} expanded, ${content.querySelectorAll('button').length} options available` :
//            `${header.textContent.trim()} collapsed`;

//        // Create live region for announcement
//        const liveRegion = document.createElement('div');
//        liveRegion.setAttribute('aria-live', 'polite');
//        liveRegion.setAttribute('aria-atomic', 'true');
//        liveRegion.style.position = 'absolute';
//        liveRegion.style.left = '-10000px';
//        liveRegion.textContent = announcement;
//        document.body.appendChild(liveRegion);

//        // Remove after announcement
//        setTimeout(() => document.body.removeChild(liveRegion), 1000);
//    }
//});